import { EReportColumnType } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalTables, TGlobalMetrics } from '../models'
import { metricTypeMap } from '../hooks/constants'

export const isPercentage = (header: TGlobalTables | TGlobalMetrics) => {
  return metricTypeMap[header].numberType === EReportColumnType.Percentage
}
